







import Vue from 'vue'
import NavigationBar from '@/components/NavigationBar.vue'

export default Vue.extend({
  name: 'App',
  data () {
    return {
      isLoading: true,
    }
  },
  async mounted () {
    await this.$store.dispatch('loadSpells')
    this.isLoading = false
  },
  components: {
    NavigationBar,
  },
})
